import { createMuiTheme } from 'material-ui';
import { colors } from 'kaizen-ui-colors/lib';

export const muiTheme = createMuiTheme({
  typography: {
    fontFamily: 'Montserrat, "Helvetica Neue", Helvetica, Arial, MyYuGothicM, YuGothic, sans-serif',
    fontSize: 13,
    button: {
      fontSize: '1rem',
      fontWeight: 600,
      textTransform: 'none',
    },
  },
  palette: {
    primary: {
      light: colors.denim_light__7fbaff,
      main: colors.denim__5fa9ff,
      dark: colors.denim_dark__477fbf,
      contrastText: '#fff',
    },
    secondary: {
      light: colors.veggie_light__57d68d,
      main: colors.veggie__2dcc70,
      dark: colors.veggie_dark__2db182,
      contrastText: '#fff',
    },
  },
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/muiTheme.ts